import { render, staticRenderFns } from "./VideoBannerWithTitleBlock.vue?vue&type=template&id=30591144"
import script from "./VideoBannerWithTitleBlock.vue?vue&type=script&lang=js"
export * from "./VideoBannerWithTitleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports